import { AccrualCodesTable } from 'components/table/accrual_codes/Table';

const AccrualCodes = () => {
    return (
        <>
        <AccrualCodesTable />
        </>
    );
}

export { AccrualCodes };